module.exports = __webpack_public_path__ + "static/media/signOut.a1ca3453.svg";